import { Table } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function AssignedSurvey({ surveyList, loader }) {
  const navigate = useNavigate();

  const handleDetailedView = (bid) => {
    console.log(bid);
    navigate("/survey-single-view", { state:  bid  });
  };

  const column = [
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Sl.No</span>
      ),
      dataIndex: "_id",
      render: (text, record, index) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {index + 1}
        </span>
      ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Client Name</span>
      ),
      dataIndex: "clientName",
      render: (clientName) => (
        <span className="text-[#313131] font-semibold text-[16px]">
          {clientName}
        </span>
      ),

      align: "center",
    },
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Phone</span>
      ),
      dataIndex: "phonePrimary",
      render: (phonePrimary) => (
        <span className="text-[#313131] font-semibold text-[16px]">
          {phonePrimary}
        </span>
      ),

      align: "center",
    },

    
    
    
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Status</span>
      ),
      dataIndex: "assignTo",
      render: (assignTo ) => {
        
        return <span>{assignTo[0]?.status}</span>;
      },
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">
          Date & Time
        </span>
      ),
      dataIndex: "createdDate",
      render: (createDate) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {moment(createDate).format("DD/MM/YYYY HH:mm")}
        </span>
      ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Actions</span>
      ),
      dataIndex: "status._id",
      align: "center",
      render: (status, _id) => (
        <>
          <div className="gap-2 flex justify-center">
            <button
              className="cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-3 text-white rounded-md  py-2 mr-2"
              onClick={() => handleDetailedView(_id._id)}
            >
              View Detail
            </button>
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="container">
      <div className="shadow-lg hover:shadow-xl rounded-xl mt-4 overflow-x-auto">
        <Table
          className="min-w-full divide-y divide-gray-200"
          //   pagination={{
          //     total: myBids?.length,
          //     showTotal: (total, range) =>
          //       `Showing ${range[0]} to ${range[1]} of ${total} entries`,
          //     showSizeChanger: true,
          //     onShowSizeChange: onShowSizeChange,
          //     itemRender: itemRender,
          //   }}
          columns={column}
          loading={loader}
          dataSource={surveyList}
          rowKey={(record) => record._id}
          
        />
      </div>
    </div>
  );
}

export default AssignedSurvey;
